<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Programs Info (Level of Care)'"            
            v-bind:titleRef="'titleElementPrograms'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Fill in the form with programs information. When complete, hit <b>Save</b> to advance to the next step.
        </p>
        
        <b-row>
            <b-col lg="3" md="3" sm="12">
              
            </b-col>
        </b-row>

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"
            v-bind:Name="'btnProgramsBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnProgramsNext'"
            v-bind:ClassProp="'mx-2'"/>  


        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnPrograms'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>

export default {
  name: 'IniPrograms',
  data(){
    return{

    }
  },
  methods:{
  Next(){
        this.$router.push({ name:'inotes'});
    },

    Back(){
        this.$router.push({ name:'itherapies'}); 
    }
  },
  mounted(){

  }   
};
</script>


